import { PHONE_REGEX } from "../../../../../../../../../../constants/regexConstants";
import { IAgentBusinessInformation } from "../../../../../../../../agentDetail.model";
import { AgentDetailFormFieldConfig } from "../agentDetailFormField/agentDetailFormField.types";

export interface BusinessFormFieldConfig extends AgentDetailFormFieldConfig {
    field: keyof IAgentBusinessInformation;
}

export const BUSINESS_FORM_FIELDS: BusinessFormFieldConfig[] = [
    { field: "businessName", label: "Agency Name", type: "text", placeholder: "Enter Agency Name" },
    {
        field: "primaryPhoneNumber",
        label: "Business Phone Number",
        type: "tel",
        placeholder: "Enter Business Phone Number",
        validate: (v) => {
            if (!v) return null;
            return PHONE_REGEX.test(v) ? null : "Please enter a valid phone number";
        },
    },
    {
        field: "addressLine1",
        label: "Business Street Address",
        type: "text",
        placeholder: "Enter Business Street Address",
    },
    {
        field: "addressLine2",
        label: "Business Street Address 2",
        type: "text",
        placeholder: "Enter Business Street Address 2",
    },
    { field: "city", label: "Business City", type: "text", placeholder: "Enter Business City" },
    { field: "state", label: "Business State", type: "select", placeholder: "Select Business State" },
    {
        field: "zipCode",
        label: "Business Zip Code",
        type: "text",
        placeholder: "Enter Business Zip Code",
        filter: (v) => v.replace(/\D/g, "").slice(0, 7),
        validate: (v) => {
            if (!v) return null;
            return /^\d{1,7}$/.test(v) ? null : "Zip code must be at most 7 digits";
        },
    },
    {
        field: "faxNumber",
        label: "Business Fax Number",
        type: "text",
        placeholder: "Enter Business Fax Number",
        filter: (v) => v.replace(/\D/g, ""),
    },
    { field: "suiteNumber", label: "Suite Number", type: "text", placeholder: "Enter Suite Number" },
    { field: "userType", label: "User Type", type: "text", placeholder: "Enter User Type" },
];

export const hasBusinessInfoErrors = (
    info: IAgentBusinessInformation | null ,
    original?: IAgentBusinessInformation | null,
): boolean => {
    if (!info) return false;
    return BUSINESS_FORM_FIELDS.some(({ field, validate }) => {
        if (!validate) return false;
        return validate(
            info[field],
            original?.[field],
        ) !== null;
    });
};